import React from "react";
import { styled } from "styled-components";
import { Alert, Col, Input, Row } from "components/bootstrap";
import { Select, Link } from "components/common";
import Routes from "routing/Routes";
import useProfileOptions from "components/indices/IndexSetFieldTypeProfiles/hooks/useProfileOptions";
const StyledAlert = styled(Alert)`
  overflow: auto;
`;
const StyledSelect = styled(Select)`
  margin-bottom: 10px;
`;
const IndexSetProfileConfiguration = ({
  value,
  onChange,
  name,
  disabled = false
}) => {
  const { isLoading, options } = useProfileOptions();
  const _onChange = (val) => onChange(val || null);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledAlert, null, "With index set field type", " ", /* @__PURE__ */ React.createElement(Link, { target: "_blank", to: Routes.SYSTEM.INDICES.FIELD_TYPE_PROFILES.OVERVIEW }, "profiles"), " ", "you can bundle up custom field types into profiles. You can assign any profile to this index set. To see and use profile setting for index set, you have to rotate indices."), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Input, { id: name, label: "Index field type mapping profile (optional)" }, /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      placeholder: "Select index field type profile",
      inputId: name,
      options,
      value,
      disabled: isLoading || disabled,
      onChange: _onChange
    }
  )))));
};
export default IndexSetProfileConfiguration;
